import styled from '@emotion/styled'
import colors from '@mathflat/common/style/colors'
import clsx from 'clsx'
import * as React from 'react'
import { useEffect, useRef } from 'react'

import { Icon } from '@/component/atoms/Icon'
import type { StyleProps } from '@/types'

import { DropdownContext } from './context'

type Props = {
  value: any
  disabled?: boolean
  children?: React.ReactNode
  isChecked?: boolean
  readOnly?: boolean
  onClick?: (e: React.MouseEvent) => void
} & StyleProps

const DropdownItem2 = ({
  value,
  disabled = false,
  readOnly,
  children,
  className,
  style,
  onClick,
}: Props) => {
  const ref = useRef<HTMLButtonElement>(null)
  const context = React.useContext(DropdownContext)
  const isActive = value === context?.value

  useEffect(() => {
    if (isActive) {
      context?.onSelect(value, children)
    }
  }, [context?.value])

  useEffect(() => {
    if (isActive) {
      context?.onSelect(value, children)
    }
  }, [children])

  return (
    <button
      disabled={disabled}
      aria-readonly={readOnly}
      className={clsx(isActive && 'active', className)}
      style={style}
      onClick={(e) => {
        if (onClick) {
          onClick(e)
        } else {
          if (readOnly) return
          context?.onSelect(value, children, true)
        }
      }}
      ref={ref}
    >
      {children}
      {isActive && <Icon name="check" className="check-icon" size={20} color={colors.gray.$900} />}
    </button>
  )
}

export default styled(DropdownItem2)`
  display: flex;
  align-items: center;
  text-align: left;

  .check-icon {
    margin-left: auto;
    display: none;
  }

  &[aria-readonly='true'] {
    border-color: ${colors.gray.$400};
    background-color: ${colors.gray.$100};
    color: ${colors.gray.$500};
    cursor: default;
  }
`
